import { render, staticRenderFns } from "./QuestionTooltip.vue?vue&type=template&id=66b3ad6e"
import script from "./QuestionTooltip.vue?vue&type=script&lang=js"
export * from "./QuestionTooltip.vue?vue&type=script&lang=js"
import style0 from "./QuestionTooltip.vue?vue&type=style&index=0&id=66b3ad6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports